<style scoped="scoped">
	.mobileCooperation{
		font-family:"SourceHanSansCN-Regular";
		font-size: 12px;
	}
	.swhz{
	background-color: white;
	text-align: center;
	padding-bottom: 30px;
}
.swhz .title_en{
	color: #E8EAEF;
	font-size: 18px;
	padding-top: 30px;
	font-weight: bold;
	text-align: center;
}
.swhz .swhz_title{
	color: #333333;
	font-size: 20px;
	margin-top: -15px;
	font-weight: 550;
}
.swhz .title_bottom img{
	margin: 6px auto 15px;
	width: 20.5%;
}
.swhz .swhz_con{
	padding: 0 4%;
}
.swhz .left_title,.swhz .right_title{
	font-size: 14px;
	font-weight: 550;
	color: #333333;
}
.swhz .left_content{
	margin-top: 20px;
}
.swhz .swhz_con .con_icon img{
	width: 12px;
	margin-right: 5px;
}
.swhz .swhz_con .icon_word{
	line-height: 26px;
	color: #666666;
}
.swhz .right_title{
	margin-top: 20px;
}
.swhz .label_img {
	position: absolute;
	left: -79px;
	/* top: 14px; */
}
.swhz .label_img img{
	width: 12px;
}
.swhz .remind{
	color: #999999;
	font-size: 12px;
	line-height: 16px;
	text-align: left;
}
.swhz .subbtnbox{
	text-align: left;
	margin-top: 20px;
}
.swhz .subbtn{
	width: 70px;
	height: 30px;
	/* margin: 20px auto 0; */
}
</style>
<style  scoped="scoped">
@import '../../../../assets/css/common.css';
</style>
<style>
	.mobileCooperation #banner .banner-item img{
    width: 100vw;
  }
  .mobileCooperation #banner .banner_content .el-carousel__indicator .el-carousel__button{
    width:12px;
    height:12px;
    background:rgba(255,255,255,1);
    border-radius:50%;
    opacity: 1;
  }
  .mobileCooperation #banner .banner_content .el-carousel__indicator.is-active .el-carousel__button{
    width:46px;
    height:12px;
    background:rgba(255,255,255,1);
    border-radius:6px;
  }
  .mobileCooperation .swiper-p1 .swiper-pagination-bullet-active {
    opacity: 1;
    background: white;
    /* background: url(../../assets/images/banner_fyq_active.gif) center center no-repeat !important; */
  }
  .mobileCooperation .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before{
    content: '';
  }
  .mobileCooperation .el-form-item__label{
    font-size: 12px;
    white-space: pre;
  }
  .mobileCooperation .el-input__inner{
    height: 24px;
    line-height: 24px;
  }
  .mobileCooperation .el-form-item__error{
    top: 73%;
  }
  .mobileCooperation .swiper-p2 .swiper-pagination-bullet{
    background-color: white;
    border:1px solid #688AE2;
  }
  .mobileCooperation .swiper-p2 .swiper-pagination-bullet.swiper-pagination-bullet-active{
    background: #688AE2;
  }
  .mobileCooperation .errmsg.el-message{
    width: 80vw !important;
    min-width: 80vw !important;
  }
  .mobileCooperation .el-textarea .el-textarea__inner{
    box-shadow:0px 0px 0px rgba(0,0,0,0);
    outline: none;
    -webkit-appearance: none;/*清除移动端textarea上边框阴影*/
  }
</style>
<template>
  <div class="mobileCooperation">
		<header class="mobilehead">
			<el-row>
				<el-col :span="4"><div style="padding-left:8px" @click="clickLogin"><img src="../../../../assets/images/icon/back.png" /></div></el-col>
				<el-col :span="16"><div class="tlc">商务合作</div></el-col>
				<el-col :span="4"><div></div></el-col>
			</el-row>
		</header>
    <div class="banner" id="banner">
      <div class="banner_content">
        <div class="swiper-container hidden-xs swiper-container1">
              <div class="swiper-wrapper">
                  <div class="swiper-slide lwc-imghandle">
                    <div class="banner-item banner-img1">
                          <img src="../../../../assets/images/front/mobilebanner4.png" alt="">
                    </div>
                  </div>
              </div>
          </div>
      </div>
    </div>
    <section class="swhz">
      <div class="swhz_box">
        <div class="title_en">BUSINESS COOPERATION</div>
        <div class="swhz_title">商务合作</div>
        <div class="title_bottom">
          <img src="../../../../assets/images/front/title_bottom.png" />
        </div>
        <div class="swhz_con">
          <div class="con_left">
            <div class="left_title">联系我们</div>
            <div class="left_content">
              <div class="clearfix">
                <div class="con_icon phone fl">
                  <img src="../../../../assets/images/front/phone_icon.png" style="margin-top:6px;" />
                </div>
                <div class="fl icon_word">热线电话：17719991109</div>
              </div>
              <div class="clearfix">
                <div class="con_icon QQ fl">
                  <img src="../../../../assets/images/front/qq_icon.png" />
                </div>
                <div class="fl">QQ：42292140（宋老师）</div>
              </div>
              <div class="clearfix">
                <div class="con_icon email fl">
                  <img src="../../../../assets/images/front/email_icon.png" style="margin-top: 9px;" />
                </div>
                <div class="fl icon_word">邮箱：42292140@qq.com</div>
              </div>
              <!-- <div class="clearfix">
                <div class="con_icon local fl">
                  <img src="../../../../assets/images/front/local_icon.png" style="margin-top: 6px;" />
                </div>
                <div class="fl icon_word">九科星北京公司：北京市东城区东四南大街189号</div>
              </div> -->
              <div class="clearfix">
                <div class="con_icon local fl">
                  <img src="../../../../assets/images/front/local_icon.png" style="margin-top: 6px;" />
                </div>
                <div class="fl icon_word">公司地址：江西省南昌市昌北经济开发区菊圃路1818号太阳城</div>
              </div>
            </div>
          </div>
          <div class="con_right" >
            <div class="right_title">在线申请</div>
            <div class="right_content">
              <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="80px" class="demo-ruleForm" label-position="left" >
                <el-form-item label="    单位名称:" prop="companyName">
                  <div class="label_img">
                    <img src="../../../../assets/images/front/company_icon.png" />
                  </div>
                  <el-input v-model="ruleForm.companyName" :maxlength="100"></el-input>
                </el-form-item>
                <el-form-item label="    联 系 人:" prop="contactsName" >
                  <div class="label_img">
                    <img src="../../../../assets/images/front/person_icon.png" />
                  </div>
                  <el-input v-model="ruleForm.contactsName" :maxlength="32"></el-input>
                </el-form-item>
                <el-form-item label="    联系电话:" prop="contactsPhone" >
                  <div class="label_img">
                    <img src="../../../../assets/images/front/phone_icon.png" />
                  </div>
                  <el-input v-model="ruleForm.contactsPhone" :maxlength="20"></el-input>
                </el-form-item>
                <el-form-item label="     留      言:" prop="message" >
                  <div class="label_img">
                    <img src="../../../../assets/images/front/message_icon.png" />
                  </div>
                  <el-input type="textarea" v-model="ruleForm.message" :maxlength="200" style="margin-top:8px;"></el-input>
                  <div class="remind">（商务经理将在1-3个工作日内联系您）</div>
                </el-form-item>
                <el-form-item>
                  <div class='subbtnbox'>
                    <el-button type="primary" @click="submitForm()" class="subbtn" v-loading="loading">提交</el-button>
                  </div>

                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- <div id="toTop" class="toTop" v-show="isShow" @click="toTop()"> -->
    </div>
    <!-- <footer>
      <div class="footer_con">
        <div class="footer_con_two">Copyright ©1996-2019 All Rights Reserved<br/>三端科技&nbsp;版权所有</div>
      </div>
    </footer> -->
  </div>
</template>

<script>
import Swiper from 'swiper'
import 'swiper/dist/css/swiper.min.css'
import commonService from '@/service/commonService'
export default {
  name: 'mobileCooperation',
  data () {
    return {
      loading: false,
      bannerHeight: 496,
	  	ruleForm: {
        companyName: '',
        contactsName: '',
        contactsPhone: '',
        message: ''
      },
      labelPosition: 'left',
      rules: {
        companyName: [
          { required: true, message: '请输入单位名称', trigger: 'blur' }
        ],
        contactsName: [
          { required: true, message: '请输入联系人', trigger: 'blur' }
        ],
        contactsPhone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          {validator: this.$rules.telephoneNumber, trigger: 'blur'}
        ],
        message: [
          { required: false, message: '请填写留言', trigger: 'blur' }
        ]
      },
      activeName: '1',
      describe_show: true,
      isShow: false,
      menulist: false,
      loginlist: false
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
    var swiper = new Swiper('.swiper-container1', {
      pagination: '.swiper-p1',
      autoplay: false,
      slidesPerView: 1,
      spaceBetween: 0,
      loop: false
    })
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    clickLogin () {
      this.pagedefault = ''
      this.$router.push({name: 'fronthome'})
      this.$nextTick(() => {
        this.pagedefault = '/'
      })
    },
    // 跳转新页面
    // openNewWin (url) {
    //   if (url) { window.open(url, '_blank') } else {
    //     this.goToPAD()
    //   }
    // },
    // },
    // 屏幕滚动
    handleScroll () {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop > 300) {
        this.isShow = true
      } else {
        this.isShow = false
      }
    },
    toTop () {
      let distanceY = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      let i = 0
      this.interval = setInterval(() => {
        if (distanceY - 60 > 0) {
          distanceY -= 60
          window.scrollTo(0, distanceY)
        } else {
          window.scrollTo(0, 0)
          clearInterval(this.interval)
        }
      }, 10)
    },
    submitForm () {
      this.loading = true
      this.$refs['ruleForm'].validate(async (valid) => {
        if (valid) {
          try {
            let data = await commonService.contractUs(this.ruleForm)
            this.loading = false
            this.$message({
              message: '申请成功,我们会稍后和您联系!',
              type: 'success',
              customClass: 'errmsg'
            })
            this.$refs['ruleForm'].resetFields()
          } catch (e) {
            this.$message.error({
              message: e && e.msg,
              customClass: 'errmsg'
            })
            this.loading = false
          }
        } else {
          this.loading = false
          this.$message.error({
            message: '请完善您的信息',
            customClass: 'errmsg'
          })
	      }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/front/mobile-page/business/index.vue